export default "<p>\n  add-credit-form works!\n</p>\n"